import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDriverTeamEntity } from '../../domain/entities/CreateUpdateDriverTeamEntity'

export class CreateUpdateDriverTeamModel extends CreateUpdateDriverTeamEntity {
  driverIds?: Array<number> | null
  channelIds?: Array<number> | null
  constructor(dataDto: CreateUpdateDriverTeamEntity) {
    super()
    mapEntityProperties<CreateUpdateDriverTeamModel>(this, dataDto, {
      exclude: ['drivers', 'channels'],
      map: {
        channelIds: dataDto.channels?.map((channel) => channel.id),
        driverIds: dataDto.drivers?.map((driver) => driver.id)
      }
    })
  }
}
